import React from 'react';
import { useHistory } from 'react-router';
import { PropsFromRedux } from '.';
import checkImg from '../../assets/images/bill-success.svg';

interface Props extends PropsFromRedux {}

const AlphaPaymentSuccessful: React.FC<Props> = ({
  hideModal,
  showModal,
  modal,
}) => {
  const history = useHistory();
  const closeModal = () => {
    hideModal();
    history.push('/');
  };

  return (
    <div className="w-full px-2 bg-white lg:px-5 py-10 relative">
      <div className="w-full my-2 flex items-center justify-center ">
        <img src={checkImg} alt="GIG App" className="w-28 my-4" />
      </div>
      <div className="w-full my-6 text-center">
        <h2 className="mb-1 text-lg font-medium text-black">
          Payment Successful
        </h2>
      </div>
      <p className="text-center">Thank you! Your payment was successful</p>
      <br />
      <button
        className="w-full bg-secondary font-medium text-sm rounded text-white py-3"
        type="button"
        onClick={() => closeModal()}
      >
        OK
      </button>
    </div>
  );
};

export default AlphaPaymentSuccessful;
